// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'
import { SubnetSourceTypeSchema } from '../inputTypeSchemas/SubnetSourceTypeSchema'

/////////////////////////////////////////
// SUBNET SCHEMA
/////////////////////////////////////////

export const SubnetSchema = z.object({
  scope: ScopeSchema,
  sourceType: SubnetSourceTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  parentId: z.string().nullable(),
  cidr: z.string(),
  version: z.number().int(),
  description: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Subnet = z.infer<typeof SubnetSchema>

export default SubnetSchema;
